import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useSupabaseAuth } from '@/hooks/auth/supabaseAuth';

export const useAdminAutoEnrollment = () => {
  const [isEnrolling, setIsEnrolling] = useState(false);
  const [enrollmentComplete, setEnrollmentComplete] = useState(false);
  const { user, userRole } = useSupabaseAuth();

  const triggerAutoEnrollment = async () => {
    if (!user || user.email !== 'iam_bal@hotmail.com' || userRole !== 'admin') {
      return;
    }

    setIsEnrolling(true);
    try {
      // Import admin setup function
      const { setupAdminUser } = await import('@/utils/adminSetup');
      const result = await setupAdminUser();
      
      console.log('Auto-enrollment result:', result);
      
      if (result.success) {
        setEnrollmentComplete(true);
        // Trigger a refresh of course data
        window.dispatchEvent(new CustomEvent('admin-enrollment-complete'));
      }
    } catch (error) {
      console.error('Auto-enrollment failed:', error);
    } finally {
      setIsEnrolling(false);
    }
  };

  useEffect(() => {
    // Auto-trigger enrollment when admin user loads
    if (user?.email === 'iam_bal@hotmail.com' && userRole === 'admin' && !enrollmentComplete) {
      const hasRun = sessionStorage.getItem('admin-auto-enrollment-triggered');
      if (!hasRun) {
        sessionStorage.setItem('admin-auto-enrollment-triggered', 'true');
        setTimeout(triggerAutoEnrollment, 1000); // Delay to allow UI to load
      }
    }
  }, [user, userRole, enrollmentComplete]);

  return {
    isEnrolling,
    enrollmentComplete,
    triggerAutoEnrollment
  };
};